import { service } from '../../../../helpers/http'

export const ActionGetRoomReservations = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceRoomReservation',
        action: 'getRoomReservations',
        payload: payload
    })
}

export const ActionPostRoomReservations = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceRoomReservation',
        action: 'postRoomReservations',
        payload: payload
    })
}

export const ActionPutRoomReservations = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceRoomReservation',
        action: 'putRoomReservations',
        payload: payload
    })
}

export const ActionDeleteRoomReservations = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceRoomReservation',
        action: 'deleteRoomReservations',
        payload: payload
    })
}

export const ActionGetRoomReservationConflicts = ({ dispatch }, payload) => {
    return service({
        module: 'domainAmbienceRoomReservation',
        action: 'getRoomReservationConflicts',
        payload: payload
    })
}
